import chroma from 'chroma-js';
import { xMinMaxValues, xyFilterX } from 'ml-spectra-processing';
/**
 * Retrieve a chart with autocorrelation color
 * @param spectraProcessor - SpectraProcessor instance
 * @param index - Index in the spectrum
 * @param options - Chart options
 * @returns Color spectrum chart object
 */
export function getAutocorrelationChart(spectraProcessor, index, options = {}) {
    const { autocorrelation = spectraProcessor.getAutocorrelation(index, options), xFilter, ids, } = options;
    const { min, max } = xMinMaxValues(autocorrelation.y);
    // eslint-disable-next-line import/no-named-as-default-member
    const colorCallback = chroma
        .scale(['blue', 'cyan', 'yellow', 'red'])
        .domain([min, max])
        .mode('lch');
    // Annoying but it seems the color library does not handle TypedArray well
    const ys = ArrayBuffer.isView(autocorrelation.y)
        ? Array.from(autocorrelation.y)
        : autocorrelation.y;
    const colorScale = ys.map((y) => `rgb(${colorCallback(y).rgb().join(',')})`);
    let mean = spectraProcessor.getMeanData({ ids });
    if (xFilter) {
        mean = xyFilterX({ x: mean.x, y: mean.y }, xFilter);
    }
    const colorSpectrum = {
        type: 'color',
        x: mean.x,
        y: mean.y,
        color: colorScale,
        styles: {
            unselected: {
                lineWidth: 1,
                lineStyle: 1,
            },
            selected: {
                lineWidth: 3,
                lineStyle: 1,
            },
        },
    };
    return colorSpectrum;
}
//# sourceMappingURL=getAutocorrelationChart.js.map